import { Context } from '../context';
import { makeNostoRecommendationsMinicart } from './nosto-integration';
import { makeAddItems } from './add-items';
import { makeChangeQuantity } from './change-quantity';
import { makeInit } from './init';
import { makeRemoveItems } from './remove-items';
import { makeUpdateNote } from './update-note';
import { makeRefresh } from './refresh';
import { reload } from './reload';
import { updateAdditionalCheckoutButtons } from './update-additional-checkout-buttons';
const { addItemsToCart , changeItemQuantity , fetchCartContents , updateCartNote  } = Context;
const afterUpdate = ()=>{
    updateAdditionalCheckoutButtons();
};
// Check if we're on a product page to determine if Nosto integration is needed
const isProductPage = typeof document !== 'undefined' && document.body.getAttribute('data-shopify-template') === 'product';
export const ActionHandler = {
    reload,
    refresh: makeRefresh({
        fetchCartContents
    }),
    addItems: makeAddItems({
        addItemsToCart,
        fetchCartContents,
        afterUpdate: afterUpdate
    }),
    changeQuantity: makeChangeQuantity({
        changeItemQuantity,
        afterUpdate: afterUpdate
    }),
    init: makeInit({
        fetchCartContents,
        onCartInitialized: isProductPage ? makeNostoRecommendationsMinicart() : undefined
    }),
    removeItems: makeRemoveItems({
        changeItemQuantity
    }),
    updateNote: makeUpdateNote({
        updateCartNote
    })
};
